import { useEffect, useState } from "react";

import { useApiCall } from "../../../../component/custom-hooks/api-call";
import { Skeleton } from "@mui/material";
import { StatCard } from "../../../../component/LeadsDashboardComponents/StatCard";

import {
  Clock,
  Today,
  RoundArrowCircle,
  Clander,
  Exit,
} from "../../../../component/LeadsDashboardComponents/StatCardIcons";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import { ProjectsByStatsChart } from "../../../../component/ProjectDashboardComponent/ProjectsByStatsChart";
import { ProjectsByBrands } from "../../../../component/ProjectDashboardComponent/ProjectsByBrands";
import { ProjectsByProducts } from "../../../../component/ProjectDashboardComponent/ProjectsByProducts";
import { RecentProjectTable } from "../../../../component/ProjectDashboardComponent/RecentProjectsTable";

const View = "myteams";

export default function TeamProjectDashboard() {
  const [dateRange] = useState("11/02/2026 - 11/02/2026");
  const [dateFilter, setDateFilter] = useState("this_month");

  const apiCall = useApiCall();

  const [overAllData, setOverAllData] = useState({});
  const [overAllLoading, setOverAllLoading] = useState(true);
  const [KPIData, setKPIData] = useState({});

  const getOverallData = async () => {
    setOverAllLoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `projects/project-overviews?view=${View}&time=${dateFilter}`,
      });
      setOverAllData(resp);
      setKPIData(resp?.kpis);
      setOverAllLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  useEffect(() => {
    getOverallData();
  }, [dateFilter]);

  const chartData = {
    categories: overAllData?.last_12_months_by_status_won_loss?.map(
      (list) => list?.month,
    ),

    data: [
      {
        name: "Total Deals",
        color: "#3B82F6",
        data: overAllData?.last_12_months_by_status_won_loss?.map(
          (d) => d?.total_deal,
        ),

        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "rgba(59,130,246,0.25)"],
            [1, "rgba(59,130,246,0.02)"],
          ],
        },
      },

      {
        name: "Won Deals",
        color: "#10B981",
        data: overAllData?.last_12_months_by_status_won_loss?.map(
          (d) => d?.won_deal,
        ),

        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "rgba(16,185,129,0.25)"],
            [1, "rgba(16,185,129,0.02)"],
          ],
        },
      },

      {
        name: "Lost Deals",
        color: "#EF4444",
        data: overAllData?.last_12_months_by_status_won_loss?.map(
          (d) => d?.lost_deal,
        ),

        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "rgba(239,68,68,0.25)"],
            [1, "rgba(239,68,68,0.02)"],
          ],
        },
      },
    ],
  };

  // console.log("chartData", chartData)
  return (
    <div className="h-full w-full overflow-auto p-5 flex flex-col">
      {!overAllLoading ? (
        <>
          {/* Header */}
          <div className="">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-3 gap-0">
              <div>
                <h1 className="text-2xl font-bold">Projects Metrics</h1>
              </div>

              {/* <div>
                <CustomDropdown
                  position="bottom-right"
                  className="myDropdown !w-[200px]"
                >
                  <CustomDropdownButton
                    arrow={true}
                    className="btnClass !w-[200px] !justify-between"
                  >
                    <h3 className="!text-[16px] capitalize">
                      {dateFilter.replace("_", " ")}
                    </h3>
                  </CustomDropdownButton>

                  <CustomDropdownMenu className="w-full">
                    {dateFilter !== "this_month" && (
                      <CustomDropdownMenuList
                        onClick={() => setDateFilter("this_month")}
                      >
                        This Month
                      </CustomDropdownMenuList>
                    )}

                    {dateFilter !== "last_month" && (
                      <CustomDropdownMenuList
                        onClick={() => setDateFilter("last_month")}
                      >
                        Last Month
                      </CustomDropdownMenuList>
                    )}
                    {dateFilter !== "this_quarter" && (
                      <CustomDropdownMenuList
                        onClick={() => setDateFilter("this_quarter")}
                      >
                        This Quarter
                      </CustomDropdownMenuList>
                    )}
                    {dateFilter !== "this_year" && (
                      <CustomDropdownMenuList
                        onClick={() => setDateFilter("this_year")}
                      >
                        This Year
                      </CustomDropdownMenuList>
                    )}
                    {dateFilter !== "all_time" && (
                      <CustomDropdownMenuList
                        onClick={() => setDateFilter("all_time")}
                      >
                        All Time
                      </CustomDropdownMenuList>
                    )}
                  </CustomDropdownMenu>
                </CustomDropdown>
              </div> */}
            </div>
          </div>

          <div className="w-full h-full">
            {/* First Row - Pipeline and Stats */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-6 mb-6">
              {!overAllLoading ? (
                <>
                  <StatCard
                    icon={Clock}
                    iconBgColor="#BBF7D0"
                    iconColor={"#16A34A"}
                    title="Total Active Projects"
                    value={KPIData?.total_active_projects}
                    progress={40}
                    progressColor="bg-[#84CC16]"
                    subLabel="All Time Count"
                  />
                  {/* <StatCard
                            icon={<UserCheck className="w-5 h-5" />}
                            iconBg="bg-blue-500"
                            title="New Leads"
                            subLabel="Daily Intake"
                            value={KPIData?.leads_today}
                            progress={40}
                            progressColor="bg-blue-500"
                            trend={`${KPIData?.lead_today_percentage}%`}
                            trendUp={false}
                          /> */}
                  <StatCard
                    icon={Today}
                    iconColor={"#FF7F50"}
                    iconBgColor="#FFEBE0"
                    title="In Progress"
                    value={KPIData?.in_progress_projects?.count}
                    progress={KPIData?.in_progress_projects?.progress}
                    progressColor="bg-[#0095FF]"
                    trend={`${KPIData?.in_progress_projects?.percentage}`}
                    trendUp={KPIData?.in_progress_projects?.trendup}
                    subLabel="This Month"
                  />
                  <StatCard
                    icon={RoundArrowCircle}
                    iconColor={"#FF4040"}
                    iconBgColor="#FEE2E2"
                    title="Rush Projects"
                    value={KPIData?.rush_projects?.count}
                    progress={KPIData?.rush_projects?.progress}
                    progressColor="bg-[#BF83FF]"
                    trend={KPIData?.rush_projects?.percentage}
                    trendUp={KPIData?.rush_projects?.trendup}
                    subLabel="Last 30 days"
                  />

                  <StatCard
                    icon={Clander}
                    iconColor={"#335CFF"}
                    iconBgColor="#DBEAFE"
                    title="Overdue Projects"
                    value={`$${KPIData?.overdue_projects?.count}`}
                    progress={KPIData?.overdue_projects?.progress}
                    progressColor="bg-[#FF7F50]"
                    trend={KPIData?.overdue_projects?.percentage}
                    trendUp={KPIData?.overdue_projects?.trendup}
                    subLabel="Last 30 days"
                  />

                  <StatCard
                    icon={Exit}
                    iconBgColor="#EDE9FE"
                    iconColor={"#6D28D9"}
                    title="Completed Projects"
                    subLabel="This Month"
                    value={KPIData?.completed_projects?.count}
                    progress={KPIData?.completed_projects?.progress ?? 40}
                    trend={KPIData?.completed_projects?.percentage}
                    trendUp={KPIData?.completed_projects?.trendup}
                    progressColor="bg-[#0E121B]"
                  />

                  {/* <StatCard
                            icon={<IdCard className="w-5 h-5" />}
                            iconBg="bg-red-500"
                            title="Active Deals in Pipeline"
                            value={KPIData?.deals_in_progress}
                            progress={40}
                            progressColor="bg-pink-500"
                            subLabel="Pipeline Status (MTD)"
                          />
            
                          <StatCard
                            icon={<FileText className="w-5 h-5" />}
                            iconBg="bg-purple-600"
                            title="Closed / Lost"
                            value={KPIData?.closed_or_lost}
                            progress={40}
                            progressColor="bg-purple-600"
                            subLabel="Recent Outcomes (MTD)"
                          /> */}
                </>
              ) : (
                Array.from({ length: 5 }).map((_, index) => (
                  <div
                    key={index}
                    className="bg-white shadow rounded-xl p-4 animate-pulse"
                  >
                    {/* Top row: label + icon */}
                    <div className="flex items-center justify-between mb-2">
                      <Skeleton variant="text" width={80} height={16} />
                      <Skeleton variant="circular" width={20} height={20} />
                    </div>
                    {/* Value row */}
                    <div className="flex items-center justify-between gap-2 mb-1 mt-2 py-[12px]">
                      <Skeleton variant="text" width={60} height={32} />
                      <Skeleton variant="rounded" width={40} height={20} />
                    </div>
                    {/* Sublabel */}
                    <Skeleton variant="text" width={80} height={12} />
                  </div>
                ))
              )}
            </div>

            {/* Second Row */}
            <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
              <div className="xl:col-span-4">
                <ProjectsByStatsChart
                  apiData={overAllData?.by_status}
                  apiLoading={overAllLoading}
                />
              </div>
              <div className="xl:col-span-4">
                <ProjectsByBrands
                  apiData={overAllData?.by_brands}
                  apiLoading={overAllLoading}
                />
              </div>
              <div className="xl:col-span-4">
                <ProjectsByProducts
                  apiData={overAllData?.by_products}
                  apiLoading={overAllLoading}
                />
              </div>
            </div>

            {/* Recent Projects */}
            <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
              <div className="xl:col-span-12 min-h-[410px]">
                <RecentProjectTable
                  data={overAllData?.recent_projects}
                  apiLoading={overAllLoading}
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <InnerLoader />
      )}
    </div>
  );
}
